import { Flex, Stack, Text } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useLocalizedCurrencyFormatter } from 'shared/utils/currency';

type OverdueTotalProps = { amount: number };

export const OverdueTotal = ({ amount }: OverdueTotalProps) => {
  const { t } = useTranslation();
  const formatter = useLocalizedCurrencyFormatter();

  return (
    <Stack gap={0} align="flex-end">
      <Flex mih={32} align="center">
        <Text size="sm" c="dimmed">
          {t(i18nKeys.GROUP.TOTAL_OVERDUE)}
        </Text>
      </Flex>
      <Text fw={600}>{formatter.format(amount)}</Text>
    </Stack>
  );
};
